const consoleRouter = [{
  path: '/login',
  name: 'login',
  meta: {
    title: '登录',
    auth: false,
  },
  component: () => import('@/console/login/login'),
},
{
  path: '/user/login',
  name: 'user_login',
  meta: {
    title: '手机号登录授权 | 验证码自动注册',
    auth: false,
  },
  component: () => import('@/console/login/loginNew'),
},
{
  path: '/console/liveInfo',
  name: 'liveInfo',
  meta: {
    title: '直播中心',
    auth: true,
    menu: 'live'
  },
  component: () => import('@/console/liveInfo/liveInfo'),
},
{
  path: '/console/edit_video',
  name: 'edit_video',
  meta: {
    title: '视频编辑',
    auth: true,
    menu: '/mate_video'
  },
  component: () => import('@/console/toolView/editVideo/editVideo'),
},
{
  path: '/console/short_video/edit',
  name: 'short_video_edit',
  meta: {
    title: '短视频编辑',
    auth: true,
    menu: 'short_video'
  },
  component: () => import('@/console/toolView/shortVideo/shortVideoEdit'),
},
{
  path: '/console/ppt_video_edit',
  name: 'ppt_video_edit',
  meta: {
    title: 'ppt视频制作',
    auth: true,
    menu: 'ppt_video_edit'
  },
  component: () => import('@/console/toolView/ppt/editVideo'),
},
{
  path: '/live_human',
  name: 'live_human',
  meta: {
    title: '直播数字人',
    auth: true,
    menu: 'liveInfo_humam'
  },
  component: () => import('@/console/liveInfo/human'),
},
{
  path: '/console/live_data',
  name: 'live_data',
  meta: {
    title: '直播中心',
    auth: true,
    menu: 'live'
  },
  component: () => import('@/console/liveData/liveData'),
},
{
  path: '/console',
  name: "console",
  redirect: {
    name: 'livelist'
  },
  component: () => import('@/console/Index'),
  children: [{
    path: 'model',
    name: 'model',
    meta: {
      title: '直播内容',
      auth: true,
      menu: 'model'
    },
    component: () => import('@/console/home/home'),
  },
  {
    path: 'live',
    name: 'live',
    meta: {
      title: '直播中心',
      auth: true,
      menu: 'live'
    },
    component: () => import('@/console/livelist/livelist'),

  },
  {
    path: 'template',
    name: 'template',
    meta: {
      title: '直播中心',
      auth: true,
      menu: 'template'
    },
    component: () => import('@/console/liveTemplate/livelist'),
  },
  {
    path: 'screenRecording',
    name: 'screenRecording',
    meta: {
      title: '运营风控',
      auth: true,
      menu: 'screenRecording'
    },
    redirect: {
      name: 'screen_recording_list'
    },
    component: () => import('@/console/screenRecording/screenRecordingIndex'),
    children: [
      {
        path: 'screen_recording_list',
        name: 'screen_recording_list',
        meta: {
          title: '直播录制-任务列表',
          auth: true,
          menu: 'screen_recording_list'
        },
        component: () => import('@/console/screenRecording/screenRecording'),
      },
      {
        path: 'screen_recording_live',
        name: 'screen_recording_live',
        meta: {
          title: '直播录制-直播间列表',
          auth: true,
          menu: 'screen_recording_live'
        },
        component: () => import('@/console/screenRecording/screenRecordingLive'),
      },
    ]
  },
  {
    path: 'video',
    name: 'video',
    meta: {
      title: '短视频提取',
      auth: true,
      menu: 'video'
    },
    component: () => import('@/console/screenRecording/video'),
  },
  {
    path: 'short_video',
    name: 'short_video',
    meta: {
      title: '短视频',
      auth: true,
      menu: 'short_video'
    },
    component: () => import('@/console/toolView/shortVideo/list'),
  },

  {
    path: 'videoText',
    name: 'videoText',
    meta: {
      title: '视频文案提取',
      auth: true,
      menu: 'videoText'
    },
    component: () => import('@/console/screenRecording/videoText'),
  },
  {
    path: 'likeRoom',
    name: 'likeRoom',
    meta: {
      title: '同行监控',
      auth: true,
      menu: 'likeRoom'
    },
    component: () => import('@/console/roomAlike/roomAlike'),
  },
  {
    path: 'likeChat',
    name: 'likeChat',
    meta: {
      title: '同行监控信息',
      auth: true,
      menu: 'likeRoom'
    },
    component: () => import('@/console/roomAlike/alikeChat'),
  },
  {
    path: 'voice',
    name: 'voice',
    meta: {
      title: '音色列表',
      auth: true,
      menu: 'voice'
    },
    component: () => import('@/console/aiView/voiceList/voiceList'),
  },
  {
    path: 'human',
    name: 'human',
    meta: {
      title: '数字人',
      auth: true,
      menu: 'human'
    },
    component: () => import('@/console/aiView/human/metaList'),
  },
  {
    path: 'human/meta_create',
    name: 'meta_create',
    meta: {
      title: '创建数字人',
      auth: true,
      menu: 'human'
    },
    component: () => import('@/console/aiView/human/metaCreate'),
  },
  {
    path: 'music',
    name: 'music',
    meta: {
      title: '音乐资源',
      auth: true,
      menu: 'music'
    },
    component: () => import('@/console/fileView/musicList/musicList'),
  },
  {
    path: 'files',
    name: 'files',
    meta: {
      title: '资源管理',
      auth: true,
      menu: 'files'
    },
    component: () => import('@/console/fileView/filesList/filesList'),
  },
  {
    path: 'goods',
    name: 'goods',
    meta: {
      title: '商品',
      auth: true,
      menu: 'goods'
    },
    component: () => import('@/console/fileView/goods/goods'),
  },
  {
    path: 'effects',
    name: 'effects',
    meta: {
      title: '特效资源',
      auth: true,
      menu: 'effects'
    },
    component: () => import('@/console/fileView/effects/effects'),
  },
  {
    path: 'temp',
    name: 'temp',
    meta: {
      title: '临时文件',
      auth: true,
      menu: 'temp'
    },
    component: () => import('@/console/tempFile/tempFile'),
  },

  {
    path: 'rule',
    name: 'newrule',
    meta: {
      title: '自动化规则',
      auth: true,
      menu: 'newrule'
    },
    component: () => import('@/console/rule/newrule'),
  },
  {
    path: 'operate',
    name: 'operate',
    meta: {
      title: '运营风控',
      auth: true,
      menu: 'operate'
    },
    redirect: {
      name: 'defriend'
    },
    component: () => import('@/console/menuReply/operateIndex'),
    children: [

      {
        path: 'defriend',
        name: 'defriend',
        meta: {
          title: '评论监控',
          auth: true,
          menu: 'operate'
        },
        component: () => import('@/console/menuReply/defriend'),
      },
      {
        path: 'monitor',
        name: 'monitor',
        meta: {
          title: '违规监控',
          auth: true,
          menu: 'operate'
        },
        component: () => import('@/console/menuReply/monitor'),
      },
      {
        path: 'mutation',
        name: 'mutation',
        meta: {
          title: '页面突变监听',
          auth: true,
          menu: 'operate'
        },
        component: () => import('@/console/menuReply/mutation'),
      },
      {
        path: 'reply',
        name: 'menuReply',
        meta: {
          title: '风控设置',
          auth: true,
          menu: 'operate'
        },
        component: () => import('@/console/menuReply/menuReply'),
      },
      {
        path: 'replyVoice',
        name: 'replyVoice',
        meta: {
          title: '话术风控',
          auth: true,
          menu: 'operate'
        },
        component: () => import('@/console/menuReply/menuVoice'),
      },
    ]
  },

  {
    path: 'order_detail',
    name: 'order_detail',
    meta: {
      title: '订单详情',
      auth: true,
      menu: 'order'
    },
    component: () => import('@/console/orderView/detail'),
  },
  {
    path: 'pay',
    name: 'pay',
    meta: {
      title: '支付订单',
      auth: true,
      menu: 'order'
    },
    component: () => import('@/console/orderView/pay'),
  },
  {
    path: 'order',
    name: 'order',
    meta: {
      title: '订单列表',
      auth: true,
      menu: 'order'
    },
    component: () => import('@/console/orderView/order'),
  },
  {
    path: 'bill',
    name: 'bill',
    meta: {
      title: '费用明细',
      auth: true,
      menu: 'bill'
    },
    component: () => import('@/console/orderView/bill'),
  },
  {
    path: 'detail',
    name: 'detail',
    meta: {
      title: '直播详情',
      auth: true,
      menu: 'live'
    },
    redirect: {
      name: 'room'
    },
    component: () => import('@/console/detail/detaiIndex'),
    children: [
      {
        path: 'room',
        name: 'room',
        meta: {
          title: '直播控制台',
          auth: true,
          menu: 'live'
        },
        component: () => import('@/console/room/room'),
      },
      {
        path: 'reply',
        name: 'reply',
        meta: {
          title: '关键词回复',
          auth: true,
          menu: 'live'
        },
        component: () => import('@/console/reply/reply'),
      },
      {
        path: 'audios',
        name: 'audios',
        meta: {
          title: 'AI回复',
          auth: true,
          menu: 'live'
        },
        component: () => import('@/console/roomAudios/list'),
      },
      {
        path: 'ai_reply',
        name: 'ai_reply',
        meta: {
          title: 'AI回复',
          auth: true,
          menu: 'live'
        },
        component: () => import('@/console/reply/aiReply'),
      },

      {
        path: 'rule',
        name: 'rule',
        meta: {
          title: '自动化规则',
          auth: true,
          menu: 'live'
        },
        component: () => import('@/console/rule/rule'),
      },
      {
        path: 'chat',
        name: 'chat',
        meta: {
          title: '房间消息',
          auth: true,
          menu: 'live'

        },
        component: () => import('@/console/chat/chat'),
      },
      {
        path: 'history',
        name: 'history',
        meta: {
          title: '脚本历史版本',
          auth: true,
          menu: 'live'

        },
        component: () => import('@/console/history/history'),
      },
      {
        path: 'business',
        name: 'business',
        meta: {
          title: '业务操作',
          auth: true,
          menu: 'live'

        },
        component: () => import('@/console/business/business'),
      },
      {
        path: 'downline',
        name: 'downline',
        meta: {
          title: '自动下播设置',
          auth: true,
          menu: 'live'
        },
        component: () => import('@/console/roomDownline/roomDownline'),
      },
      {
        path: 'stage',
        name: 'stage',
        meta: {
          title: '直播脚本',
          auth: true,
          menu: 'live'

        },
        component: () => import('@/console/stageList/stageList'),
      },
      {
        path: 'stages',
        name: 'stages',
        meta: {
          title: '直播脚本',
          auth: true,
          menu: 'live'
        },
        component: () => import('@/console/stageList/stageListOld'),
      },
      {
        path: 'view',
        name: 'view',
        meta: {
          title: '直播间装饰',
          auth: true,
          menu: 'live'
        },
        component: () => import('@/console/view/view'),
      },
      {
        path: 'temofile',
        name: 'room_temofile',
        meta: {
          title: '主播说话',
          auth: true,
          menu: 'live'
        },
        // component: () => import('@/console/roomTempFile/tempFile'),
        component: () => import('@/console/roomTempFile/tempFileNew'),

      },
      {
        path: 'meta',
        name: 'meta',
        meta: {
          title: '数字人',
          auth: true,
          menu: 'live'
        },
        component: () => import('@/console/roomMetaHuman/roomMetaHuman'),
      },
    ]
  },
  {
    path: 'monitors',
    name: 'monitors',
    meta: {
      title: '直播监控',
      auth: true,
      menu: 'monitors'
    },
    component: () => import('@/console/toolView/monitors/list'),
  },
  {
    path: 'live_monitors',
    name: 'live_monitors',
    meta: {
      title: '监控报告',
      auth: true,
      menu: 'monitors'
    },
    component: () => import('@/console/toolView/monitors/liveMonitors'),
  },
  {
    path: 'task',
    name: 'task',
    meta: {
      title: '小黄车弹屏',
      auth: true,
      menu: 'task'
    },
    component: () => import('@/console/toolView/task/taskList'),
  },
  {
    path: 'create_task',
    name: 'create_task',
    meta: {
      title: '创建弹屏任务',
      auth: true,
      menu: 'task'
    },
    component: () => import('@/console/toolView/task/createTask'),
  },
  {
    path: 'mate_video',
    name: 'mate_video',
    meta: {
      title: '数字人短视频',
      auth: true,
      menu: 'mate_video'
    },
    redirect: {
      name: 'mate_video_list'
    },
    component: () => import('@/console/toolView/metaVideo/metaIndex'),
    children: [
      {
        path: 'mate_video_list',
        name: 'mate_video_list',
        meta: {
          title: '数字人短视频',
          auth: true,
          menu: 'mate_video'
        },
        component: () => import('@/console/toolView/metaVideo/list'),
      },
      {
        path: 'draft',
        name: 'draft',
        meta: {
          title: '数字人短视频',
          auth: true,
          menu: 'mate_video'
        },
        component: () => import('@/console/toolView/metaVideo/draft'),
      },

    ]
  },

  {
    path: 'create_meta_video',
    name: 'create_meta_video',
    meta: {
      title: '创建短视频',
      auth: true,
      menu: 'mate_video'
    },
    component: () => import('@/console/toolView/metaVideo/metaView'),
  },
  {
    path: 'clone_list',
    name: 'clone_list',
    meta: {
      title: '克隆声音列表',
      auth: true,
      menu: 'clone_list'
    },
    component: () => import('@/console/toolView/cloneVoice/list'),
  },
  {
    path: 'clone_voice',
    name: 'clone_voice',
    meta: {
      title: '克隆声音',
      auth: true,
      menu: 'clone_list'
    },
    component: () => import('@/console/toolView/cloneVoice/cloneVoice'),
  },
  {
    path: 'secret',
    name: 'secret',
    meta: {
      title: '访问密钥',
      auth: true,
      menu: 'secret'
    },
    component: () => import('@/console/accountView/secret/secretList'),
  },
  {
    path: 'account',
    name: 'account',
    meta: {
      title: '平台账号',
      auth: true,
      menu: 'account'
    },
    component: () => import('@/console/accountView/account/accountList'),
  },

  {
    path: 'field',
    name: 'field',
    meta: {
      title: '文字场控',
      auth: true,
      menu: 'field'
    },
    component: () => import('@/console/toolView/field/fieldList'),
  },
  {
    path: 'create_field',
    name: 'create_field',
    meta: {
      title: '创建文字场控任务',
      auth: true,
      menu: 'field'
    },
    component: () => import('@/console/toolView/field/createdField'),
  },
  {
    path: 'user',
    name: 'user',
    meta: {
      title: '个人中心',
      auth: true,
      menu: 'user'
    },
    component: () => import('@/console/user/user'),
  },
  {
    path: 'ppt_video_list',
    name: 'ppt_video_list',
    meta: {
      title: '个人中心',
      auth: true,
      menu: 'ppt_video_list'
    },
    component: () => import('@/console/toolView/ppt/list'),
  }
  ],
}]
export default consoleRouter
